export function htmlDecodeString(inputString:string): string{
    const doc = new DOMParser().parseFromString(inputString, "text/html");
  return doc.documentElement.textContent || '';
}